import { List } from 'immutable';
import * as React from 'react';
import { Option } from 'react-select';

import { actions } from '../../ducks/MessageForm';
import GlyphPopover from '../../lib/components/GlyphPopover';
import { getDispatch } from '../../lib/dispatchExporter';
import I18n from '../../lib/i18n';
import notify from '../../lib/notify';
import { ICountry } from '../../models/Message';
import Product from '../../models/Product';
import ProductList from '../../models/ProductList';
import ProductDragContainer from './DragComponents/ProductDragContainer';

interface IProps {
  featuredProducts: ProductList;
  countries: List<ICountry>;
  semanticsVersion: number;
  errors?: string[];
  platforms: string[];
}

interface IState {
  nsUid: string;
}

export default class FeaturedForm extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      nsUid: '',
    };
  }
  private dispatch = getDispatch();
  
  private limitExceeded = () => {
    const { featuredProducts } = this.props;
    return featuredProducts.productListLimitExceeded(this.maxProductsLength(), I18n.t('featured_products.selector.label'));
  }

  private notifyProductNotFound = () => {
    notify({
      title: '',
      message: I18n.t('message_details.error.product_not_found'),
      type: 'danger'
    });
  }

  public selectProduct = (e: Option<string>) => {
    const nsUid = e.value;
    if (nsUid === undefined) { return; }
    if (this.limitExceeded()) {
      return; 
    }
    this.dispatch(actions.selectFeaturedProduct(nsUid));
    if (Product.isSoftDetail(nsUid)) {
      this.dispatch(actions.fetchRelatedChannelsRequest({ nsUid }));
    }
  }

  public handleSort = ({ oldIndex, newIndex }: { oldIndex: number, newIndex: number }) => {
    this.dispatch(actions.sortFeaturedProducts({ oldIndex, newIndex }));
  }

  public handleUnselect = (id: string) => {
    this.dispatch(actions.unselectFeaturedProduct(id));
  }

  public maxProductsLength = () => {
    // FeaturedFormはdisplayType.NORMALではrenderされない
    // RANKINGとLISTの選択数は同じという条件が前提
    const displayType = (window as any).Constants.message.displayTypes.RANKING;
    const { semanticsVersion } = this.props;
    if (semanticsVersion >= 6) {
      return (window as any).Constants.validators.message.maxProductsLength[displayType];
    } else {
      return (window as any).Constants.validators.message.maxProductsLengthSemanticsVersion5OrBelow[displayType];
    }
  }

  public handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ nsUid : e.target.value });
  }

  public handleClick = () => {
    if (this.limitExceeded()) {
      return; 
    };
    const nsUid = this.state.nsUid.trim();
    if (!nsUid) {
      this.notifyProductNotFound();
      return;
    }
    const { featuredProducts, platforms } = this.props;
    // 重複チェック
    if (featuredProducts.selectedIds.includes(nsUid)) {
      this.dispatch(actions.fetchProductByIdFailed(I18n.t('message_details.error.product_duplicated')));
      notify({
        title: '',
        message: I18n.t('message_details.error.product_duplicated'),
        type: 'danger',
      });
      return;
    }
    this.dispatch(actions.fetchFeaturedProductByIdRequest({
      nsUid,
      platforms,
      afterFetch: (succeeded: boolean) => {
        if (succeeded) {
          this.setState({nsUid: ''});
        } else {
          this.notifyProductNotFound();
        }
      }
    }));
  }

  public renderError = () => {
    const { errors } = this.props;

    if (errors) {
      return(
        <div className="col-md-10 has-error">
          <span className="help-block">{errors.join(',')}</span>
        </div>
      );
    }

    return null;
  }

  public render() {
    const { featuredProducts, countries, platforms } = this.props;
    const { nsUid } = this.state;
    const parentFormName = '';

    return (
      <div>
        <label htmlFor="related-products" className="control-label">
          {I18n.t('featured_products.selector.label')}
        </label>
        <GlyphPopover
          title={I18n.t('featured_products.selector.tooltip', {maximum: this.maxProductsLength()})}
          body={I18n.t('messages.tooltips.products')}
        />
        <br />
        <div className="row">
          <div className="col-md-7">
            <input type="text"
              name="related-products-input"
              placeholder={I18n.t('message_details.form.fetch_product_by_id_placeholder')}
              value={nsUid}
              className="form-control"
              onChange={this.handleChange}
            />
          </div>
          <div className="col-md-5" style={{ marginBottom: '10px' }}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.handleClick}
              disabled={!nsUid || featuredProducts.isFetching || !countries.size}
            >
              {I18n.t('common.action.add')}
            </button>
          </div>
          <div className='col-md-12' >
            <ProductDragContainer
              $$products={featuredProducts}
              countries={countries}
              sortProducts={this.handleSort}
              unselectProduct={this.handleUnselect}
              platforms={platforms}
              {...{ parentFormName }}
            />
          </div>
          { this.renderError() }
        </div>
      </div>
    );
  }
}
